import { render, staticRenderFns } from "./UserTypeAdd.vue?vue&type=template&id=6a2b8f06&scoped=true"
import script from "./UserTypeAdd.vue?vue&type=script&lang=js"
export * from "./UserTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./UserTypeAdd.vue?vue&type=style&index=0&id=6a2b8f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b8f06",
  null
  
)

export default component.exports